import { Navigate, RouteObject } from 'react-router-dom';
import { isAuthenticated } from '../utils/auth-utils';
import DashboardHome from '../pages/dashboard/home';
import PaymentHistory from '../pages/dashboard/payment-history';
import MyPosts from '../pages/dashboard/my-posts';
import UsageRights from '../pages/dashboard/usage-rights';
import Resources from '../pages/dashboard/resources';
import Submissions from '../pages/dashboard/submissions';

const createProtectedRoute = (path: string, Component: React.ComponentType): RouteObject => ({
  path,
  element: isAuthenticated() ? <Component /> : <Navigate to={`/dashboard/login?next=${path}`} />,
});

export const dashboardRoutes: RouteObject[] = [
  {
    path: '/dashboard',
    element: isAuthenticated() ? <DashboardHome /> : <Navigate to="/dashboard/login" />,
  },
  createProtectedRoute('/dashboard/payment-history', PaymentHistory),
  createProtectedRoute('/dashboard/my-posts', MyPosts),
  createProtectedRoute('/dashboard/usage-rights', UsageRights),
  createProtectedRoute('/dashboard/resources', Resources),
  createProtectedRoute('/dashboard/submissions', Submissions),
];
